import React from "react";
import { useParams } from "react-router-dom";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import { useSelector } from "react-redux";
import { tutors } from "../../constants";

const RoomPage = () => {
  const { roomId } = useParams();
  const tutor = tutors.filter((tutor) => tutor.id == roomId);
  console.log(tutor[0].name);

  // const roomId = 2;
  const userInfo = useSelector((state) => state.amazonReducer.userInfo);

  const myMeeting = async (element) => {
    const appID = 2088360327;
    const serverSecret = "c19897e0436341b2af76cee67c2f1f37";
    const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
      appID,
      serverSecret,
      roomId,
      userInfo._id,
      userInfo.userName
    );
    const zc = ZegoUIKitPrebuilt.create(kitToken);
    zc.joinRoom({
      container: element,
      sharedLinks: [
        {
          name: "Copy link",
          //   url: `http://localhost:5173/room/${tutorName}`,
          url: `http://localhost:5173/room/${roomId}`,
        },
      ],
      scenario: {
        mode: ZegoUIKitPrebuilt.OneONoneCall,
      },
      showScreenSharingButton: false,
    });
  };

  return (
    <div>
      <h2 class="text-3xl font-bold text-center text-blue-950 mb-4">
        Tutor name: <span class="text-xl font-normal">{tutor[0].name}</span>
      </h2>
      <div ref={myMeeting} />
    </div>
  );
};

export default RoomPage;
